import { split } from "lodash";
import { useLocation } from "react-router-dom";
import { PageLoading, TypedResolver } from "src/components";

import {
  loadCitySettings,
  validateVendorURL,
  loadPeriodTypes,
  loadBulkyItemsTypes,
  loadCategoryTypes,
} from "src/redux/reducers";
import { useAppDispatch } from "src/redux/store";
import SchedulerWizardPage from "./SchedulerWizardPage";

const SchedulerWizardPageResolver = () => {
  const dispatch = useAppDispatch();
  const { pathname } = useLocation();
  const vendorURL = split(pathname, "/")[1];

  const loadDependencies = async () => {
    if (vendorURL) {
      const isValid = await validateVendorURL(vendorURL)(dispatch);
      if (!isValid) return Promise.reject();
      return Promise.all([
        loadCitySettings()(dispatch),
        loadPeriodTypes()(dispatch),
        loadBulkyItemsTypes()(dispatch),
        loadCategoryTypes()(dispatch),
      ]);
    } else {
      return Promise.reject();
    }
  };

  return (
    <TypedResolver
      successComponent={SchedulerWizardPage}
      resolve={loadDependencies}
      loadingComponent={PageLoading}
      redirectOnError={`/`}
    />
  );
};

export default SchedulerWizardPageResolver;
